module.exports = VueQuillEditor;